import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock, Users, ChefHat, ArrowRight } from 'lucide-react';
import { recipes } from './recipeData';
import './Recipes.css';

const Recipes: React.FC = () => {
  useEffect(() => {
    document.title = 'Recipes - HomeCookt';
  }, []);

  return (
    <div className="recipes-page">
      <section className="recipes-hero">
        <div className="recipes-hero-content">
          <h1 className="recipes-page-title">Recipes</h1>
          <p className="recipes-page-subtitle">
            Simple recipes you can cook at home in about an hour.
          </p>
        </div>
      </section>

      <section className="recipes-grid-section">
        <div className="recipes-grid-container">
          <div className="recipes-grid">
            {recipes.map((recipe) => (
              <article key={recipe.id} className="recipe-card">
                <div className="recipe-card-flag">{recipe.flag}</div>
                <h2 className="recipe-card-name">{recipe.name}</h2>
                <p className="recipe-card-cuisine">{recipe.cuisine}</p>
                <p className="recipe-card-description">{recipe.description}</p>
                <div className="recipe-card-meta">
                  <span className="recipe-meta-item">
                    <Clock size={15} />
                    {recipe.totalTime}
                  </span>
                  <span className="recipe-meta-item">
                    <Users size={15} />
                    Serves {recipe.servings}
                  </span>
                  <span className="recipe-meta-item">
                    <ChefHat size={15} />
                    {recipe.difficulty}
                  </span>
                </div>
                <Link to={`/recipes/${recipe.slug}`} className="recipe-card-button">
                  View Recipe
                  <ArrowRight size={16} />
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Recipes;
